import getFormFields from 'EstruturaAntiga/actions/usuarios/getFormFields';
import getAccountById from 'EstruturaAntiga/actions/account/getAccountById';
import getPerfil from 'EstruturaAntiga/actions/usuarios/getPerfi';
import { mapUserFieldsV2toV1 } from 'EstruturaAntiga/assets/userHelpers';
import DireitosPortalService from 'services/DireitosPortalService';
import UsuariosService from 'services/UsuariosService';
import * as HttpRequest from "EstruturaAntiga/assets/httpRequest";
import ListasPrecoService from 'services/ListasPrecoService';

export const rdxGetPerfis = () => {
  return dispatch =>
    getPerfil().then(obj => {
      dispatch({
        type: 'USUARIO_LISTA_PERFIS',
        payload: obj.map(el => {
          return { value: el.codigoTipoPerfilAcessoDireito, label: el.tipoPerfilAcessoDireito };
        })
      });
    });
};

export const rdxGetLinhaServico = () => {
  return dispatch =>
  DireitosPortalService.ListarDireitosGestaoUsuario().then(obj => {
      dispatch({
        type: 'USUARIO_LINHA_SERVICO',
        payload: obj.map(el => {
          return { 
            value: el.direitoId, 
            label: `${el.linhaDeServico ?? ''} - ${el.nome ?? ''}`,
            LinhaDeServico: el.linhaDeServico,
            Direito: el.nome
          };
        })
      });
    });
};

export const rdxGetPerfisUsuarioSelecionado = usuarioId => {
  return dispatch =>
    UsuariosService.ListarPerfisDeAcesso(usuarioId).then(obj => {
      dispatch({
        type: 'USUARIO_LISTA_PERFIS_ASSOCIADOS',
        payload: obj.map(e => {
          return {
            PerfilDeAcesso: e.perfilDeAcesso,
            PerfilDeAcessoCodigo: e.perfilDeAcessoCodigo,
            DireitoId: e.direitoId,
            LinhaDeServico: e.linhaDeServico,
            Direito: e.direito,
            Rotulo: `${e.linhaDeServico ?? ''} - ${e.direito ?? ''}`
          };
        })
      });
    });
};

export const rdxIncluirPerfilAssociado = perfil => ({
  type: 'USUARIO_INCLUIR_PERFIL_ASSOCIADO',
  payload: perfil
});

export const rdxSetEditUser = user => ({
  type: 'USUARIO_EDITANDO',
  payload: user
});

export const rdxRemoverPerfilAssociado = perfil => ({
  type: 'USUARIO_REMOVER_PERFIL_ASSOCIADO',
  payload: perfil
});

export const rdxClearUsers = editable => ({
  type: 'USUARIOS_CLEAR',
  payload: editable
});

export const rdxGetUserFields = params => {
  return dispatch =>
    getFormFields(params).then(obj => {
      dispatch({ type: 'USUARIO_FORM_FIELDS', payload: obj });
    });
};

export const rdxGetUser = params => {
  return dispatch =>
    UsuariosService.ObterUsuario(params).then(obj => {
      dispatch({ type: 'GET_USER', payload: mapUserFieldsV2toV1(obj) });
    });
};

export const rdxGetAccountById = () => {
  return dispatch =>
    getAccountById().then(obj => {
      dispatch({ 
        type: 'GET_ACCOUNT_BY_ID', 
        payload: obj 
      });
    });
};

export const rdxGetPlansRightsByEntitlementId = () => {  
  const userSignature = HttpRequest.userSignature();
  const tenant = JSON.parse(sessionStorage.getItem('tenant'));
  var tenantId = userSignature.axtTenantId;
  var direitoId = userSignature.entitlementId;
  var modeloDeOfertaCodigo = tenant.modeloOferta;
  return dispatch =>
    ListasPrecoService.ListarPlanosPorDireito(tenantId, direitoId, modeloDeOfertaCodigo).then(obj => {
      dispatch({
        type: 'USUARIOS_LISTA_PLANOS_POR_DIREITO',
        payload: obj.map(el => {
          return {
            value: el.produtoId,
            label: `${el.produto} - ${el.simboloMoeda} ${el.valorVendaBhs}${el.unidade ? ' | ' + el.unidade : ''}`,
            currencyName: el.moeda,
            currencySymbol: el.simboloMoeda,
            amount: el.valorVendaBhs,
            unitId: el.unidadeId,
            unit: el.unidade,
            produtoAssociadoId: el.produtoAssociadoId
          };
        })
      });
    });
};

export const rdxGetAdditionalProductsRightByEntitlementId = () => {
  const userSignature = HttpRequest.userSignature();
  const tenant = JSON.parse(sessionStorage.getItem('tenant'));
  var tenantId = userSignature.axtTenantId;
  var direitoId = userSignature.entitlementId;
  var modeloDeOfertaCodigo = tenant.modeloOferta;
  return dispatch =>
    ListasPrecoService.ListarLicencasAdicionaisPorDireito(tenantId, direitoId, modeloDeOfertaCodigo).then(obj => {
      dispatch({
        type: 'USUARIOS_LISTA_PLANOS_ADICIONAIS_POR_DIREITO',
        payload: obj.map(el => {
          return {
            value: el.produtoId,
            label: `${el.produto} - ${el.simboloMoeda} ${el.valorVendaBhs}${el.unidade ? ' | ' + el.unidade : ''}`,
            currencyName: el.moeda,
            currencySymbol: el.simboloMoeda,
            amount: el.valorVendaBhs,
            unitId: el.unidadeId,
            unit: el.unidade
          };
        })
      });
    });
};
